import { Link } from "react-router-dom";
import { useDemoRequest } from "@/components/feature/DemoRequest";

interface Props {
  productName: string;
}

export default function ProductCTA({ productName }: Props) {
  const { open } = useDemoRequest();
  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
            Ready to see {productName.replace("StackMap ", "")} in action?
          </h2>
          <p className="text-base text-silver-400 mb-6 max-w-xl mx-auto">
            Get a personalized demo tailored to your operations, team size, and goals.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button onClick={open} className="btn-primary w-full sm:w-auto">
              Request a Demo
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs" />
              </span>
            </button>
            <Link to="/products" className="btn-outline w-full sm:w-auto">
              Explore All Products
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
